<template>
    <div>
        <el-form :inline="true" class="forTbFilter">
            <el-form-item label="操作时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getBgdRechargeListHandler" plain icon="el-icon-search">查询</el-button>
                <el-button type="success" @click="showRecharge"  plain icon="el-icon-s-ticket">excle充值</el-button>
                 <el-button type="success" @click="showRecharge1"  plain icon="el-icon-s-ticket">号段充值</el-button>
                  <el-button type="primary" @click="showRecharge2">卡号充值</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}"   >
             <el-table-column prop="startIccid" label="ICCID开始号段" align="center"></el-table-column>
            <el-table-column prop="endIccid" label="ICCID结束号段" align="center"></el-table-column>
            <el-table-column prop="insertPkgTotal" label="导入数量" align="center"></el-table-column>
            <el-table-column prop="insertPkgSuccess" label="成功数量" align="center"></el-table-column>
            <el-table-column prop="insertPkgFail" label="失败数量" align="center"></el-table-column>
             <el-table-column label="充值总金额（元）" width="120" align="center"> 
                <template v-slot="scope" >{{ scope.row.totalPrice / 100}}</template>
            </el-table-column>
            <el-table-column prop="pkgName" label="套餐名称" align="center"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="操作人" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.insertPkgFail > 0" type="text" @click="getBgdRechargeFailListHandler(scope.row.id, $event)">查看失败</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true"  title="批量充值" :visible.sync="rechargeVisible" width="600px" :close-on-click-modal="false">
            <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/invest/agent/list')" :data="rechargeForm" :headers="setHeader()" :limit="1" :auto-upload="false" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=invest')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="套餐组：" prop="groupId">
                    <el-select v-model="rechargeForm.groupId" @change="changeHandler" filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="套餐名称：" prop="soldPackageId">
                    <el-select v-model="rechargeForm.soldPackageId" clearable>
                        <el-option v-for="item in pkgList" :value="item.id" :key="item.id" :label="item.packageName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="rechargeForm.isNextMonth" clearable>
                        <el-option value="0" label="本月生效"></el-option>
                        <el-option value="1" label="次月生效"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="rechargeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureRechargeHandler">确 定</el-button>
            </div> 
        </el-dialog>
        <el-dialog :append-to-body="true"  title="号段充值" :visible.sync="rechargeVisible1" width="600px" :close-on-click-modal="false">
            <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeRules" label-width="100px">
                <el-form-item label="开始ICCID" prop="startIccid">
                    <el-input v-model="rechargeForm.startIccid" placeholder="支持虚拟号段,根据输入卡号 自动识别套餐组" clearable></el-input>
                </el-form-item>
                 <el-form-item label="结束ICCID" prop="endIccd">
                    <el-input v-model="rechargeForm.endIccd" clearable placeholder="支持虚拟号段"  @change="seletBaseGroupIccid"></el-input>
                </el-form-item>
                <el-form-item label="套餐组：" prop="groupId">
                    <el-select v-model="rechargeForm.groupId" @change="changeHandler" filterable>
                        <el-option v-for="item in pkgGroups" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="套餐名称：" prop="soldPackageId">
                    <el-select v-model="rechargeForm.soldPackageId" clearable>
                        <el-option v-for="item in pkgList" :value="item.id" :key="item.id" :label="item.packageName"></el-option>
                    </el-select>
                </el-form-item>
                <p style="color:red">如果套餐是加油包或者套餐规则是顺延系列，请务必选择本月生效</p>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="rechargeForm.isNextMonth" clearable>
                        <el-option value="0" label="本月生效"></el-option>
                        <el-option value="1" label="次月生效"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="rechargeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel1">取 消</el-button>
                <el-button type="primary" @click="sureRechargeHandler1">确 定</el-button>
            </div> 
        </el-dialog>
        <el-dialog :append-to-body="true"  title="充值失败记录" :visible.sync="failVisible" width="1000px" :close-on-click-modal="false" @close="cancel">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column prop="intoNo" label="接入号"></el-table-column>
                <el-table-column prop="createTime" label="出错时间"></el-table-column>
                <el-table-column prop="failReason" label="失败原因"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>


        <el-dialog :append-to-body="true"  title="卡号充值" :visible.sync="rechargeVisible2" width="600px" :close-on-click-modal="false">
            <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeRules" label-width="100px">
                  <el-form-item label="充值卡号：" class="iccid_textarea_range">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入1个或多个虚拟号或者ICCID号,多个请用逗号、空格、或者换行分隔"
                    v-model="rechargeForm.iccidStr">
                    </el-input>
                </el-form-item>
                <el-form-item label="套餐组：" prop="groupId">
                    <el-select v-model="rechargeForm.groupId" @change="changeHandler" filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="套餐名称：" prop="soldPackageId">
                    <el-select v-model="rechargeForm.soldPackageId" clearable>
                        <el-option v-for="item in pkgList" :value="item.id" :key="item.id" :label="item.packageName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="rechargeForm.isNextMonth" clearable>
                        <el-option value="0" label="本月生效"></el-option>
                        <el-option value="1" label="次月生效"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="rechargeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureRechargeHandler2">确 定</el-button>
            </div> 
        </el-dialog>



    </div>
</template>

<script>
import {getBgdRechargeList, getBgdRechargeFailList, getPkgListOfGroup,getBgdRechargeFailList1,getBgdRechargeFailList2} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                time: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            rechargeVisible: false,    //批量充值
             rechargeVisible1: false,    //批量充值
            rechargeForm: {
                groupId: '',
                soldPackageId: '',
                isNextMonth: '0',
                remark: '',
                startIccid:'',
                endIccd:''
            },
            pkgGroup: [],
            pkgGroups: [],
            pkgList: [],
            failVisible: false,     //查看失败
            currentId_fail: '',
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            rechargeRules: {},
             rechargeVisible2:false,
        }
    },
    methods: {
         showRecharge2(){
            
            this.rechargeVisible2 = true;
            common.getAgentPkgGroupListCom(this, 'pkgGroup');            
        },
          sureRechargeHandler2(){
              var data = this.rechargeForm;
                        getBgdRechargeFailList2(data).then(res => {
                            if(res.data.code == 200){
                                this.$message.success('导入完成！');
                                this.getBgdRechargeListHandler();
                                  this.rechargeVisible2 = false;
                            }else{
                                this.$message.error(res.data.message);
                            }
                 })   
          
        },
        cancel(){
            this.rechargeVisible = false;
             this.rechargeVisible1 = false;
              this.rechargeVisible2 = false;
        },




          seletBaseGroupIccid(){
            common.sysRequest('pkg/group/list/iccid', {'iccid': this.rechargeForm.startIccid}, 'post').then(res => {  
                if(res.data.code == 200){
                   this.pkgGroups=res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
         cancel1(){
            this.rechargeVisible = false;
            this.rechargeVisible1 = false;
            this.rechargeForm.startIccid='';
            this.rechargeForm.endIccd='';
            this.rechargeForm.groupId='';
            this.rechargeForm.soldPackageId='';
            this.pkgGroups=[];

        },
        getBgdRechargeListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getBgdRechargeList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getBgdRechargeFailListHandler(id, $event){
            this.failVisible = true;
            this.currentId_fail = id;
            var data = {
                'recordId': id
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', data);

            getBgdRechargeFailList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showRecharge(){
            this.rechargeVisible = true;
            common.getAgentPkgGroupListCom(this, 'pkgGroup');            
        },
        showRecharge1(){
            
            this.rechargeVisible1 = true;
            common.getAgentPkgGroupListCom(this, 'pkgGroup');            
        },
        changeHandler(){
            this.rechargeForm.soldPackageId = '';
            var data = {
                groupId: this.rechargeForm.groupId
            }      
            getPkgListOfGroup(data).then(res => {
                if(res.data.code == 200){
                    this.pkgList = res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }
            }) 
        },
        sureRechargeHandler(){
            this.$refs.upload.submit();   
            this.rechargeVisible1 = false;
             this.getBgdRechargeListHandler();
        },
            sureRechargeHandler1(){
              var data = this.rechargeForm;
                        getBgdRechargeFailList1(data).then(res => {
                            if(res.data.code == 200){
                                this.$message.success('导入完成！');
                                this.getBgdRechargeListHandler();
                                  this.rechargeVisible1 = false;
                            }else{
                                this.$message.error(res.data.message);
                                  this.rechargeVisible1 = false;
                                 this.getBgdRechargeListHandler();
                            }
                 })   
          
        },
        handleSuccess(res){
            if(res.code == 200){
                this.rechargeVisible = false;
                this.getBgdRechargeListHandler();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }

            this.$refs.upload.clearFiles();
        },
        handleSizeChange(val){
            if(this.failVisible){
                this.tbpg_fail.pageSize = val;
                this.getBgdRechargeFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getBgdRechargeListHandler();
            }
        },
        handleCurrentChange(val){
            if(this.failVisible){
                this.tbpg_fail.currentPage = val;
                this.getBgdRechargeFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getBgdRechargeListHandler();
            }
        }
    },
    created(){
        this.getBgdRechargeListHandler();
    }
}
</script>

<style lang="less" scoped>

</style>

